import { PaginationMeta } from '@/models/templates/pagination.model'
import React from 'react'

const primary = '#7b2a40'

interface Props {
  meta?: PaginationMeta
  page: number
  perPage: number
  onPageChange: (page: number) => void
  onPerPageChange: (limit: number) => void
  isPreviousData?: boolean
}

export const Paginator: React.FC<Props> = ({
  meta,
  page,
  perPage,
  onPageChange,
  onPerPageChange,
  isPreviousData,
}) => {
  const totalPages = meta ? Math.ceil(meta.total / meta.perPage) : 1

  return (
    <div className="flex flex-col md:flex-row items-center justify-between gap-3 mt-6">
      <p className="text-sm text-gray-600">
        {meta
          ? <>Page <span className="font-semibold">{page}</span> of {totalPages} — Total {meta.total}</>
          : '—'}
      </p>

      <div className="flex items-center gap-2">
        <select
          value={perPage}
          onChange={(e) => onPerPageChange(Number(e.target.value))}
          className="border rounded-md px-2 py-1 text-sm"
        >
          {[10, 25, 50, 100].map(v => <option key={v}>{v}</option>)}
        </select>

        <button
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1 || isPreviousData}
          className="px-3 py-1 border rounded-md text-sm"
          style={{ borderColor: primary, color: primary }}
        >
          Prev
        </button>
        <button
          onClick={() => onPageChange(page + 1)}
          disabled={page >= totalPages || isPreviousData}
          className="px-3 py-1 border rounded-md text-sm"
          style={{ borderColor: primary, color: primary }}
        >
          Next
        </button>
      </div>
    </div>
  )
}
